import { Modal, Button, Table, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { LayerStyleHelper } from '../../util/StyleHelper';
import DataDownload from '../DataDownload';
import DownloadStatus from '../DownloadStatus';
import { useState } from 'react';
import { formatTitle } from '../../util/TitleHelper';

const DataModal = (props) => {
  const navitage = useNavigate();
  const { onHide, data } = props;
  const [loading, setLoading] = useState(false);
  const [downloadStatus, setDownloadStatus] = useState(null);
  const [downloadError, setDownloadError] = useState(null);

  const itemGis = props.getGisService(data);
  const sld = LayerStyleHelper(itemGis.layer_name);
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const layerName = itemGis.layer_name.includes(':')
    ? itemGis.layer_name.split(':')[1]
    : itemGis.layer_name;
  let wms_thumbnail;
  if (sld && sld.includes('_std')) {
    wms_thumbnail =
      `${process.env.REACT_APP_API_URL}/Utility/wms_thumbnail?wms_url=` +
      itemGis.service_url +
      `&layer_name=` +
      layerName +
      `&width=200&height=200` +
      `&sld_style=${sld}`;
  } else if (sld) {
    wms_thumbnail =
      `${process.env.REACT_APP_API_URL}/Utility/wms_thumbnail?wms_url=` +
      itemGis.service_url +
      `&layer_name=` +
      sld +
      `&width=200&height=200`;
  } else {
    wms_thumbnail =
      `${process.env.REACT_APP_API_URL}/Utility/wms_thumbnail?wms_url=` +
      itemGis.service_url +
      `&layer_name=` +
      layerName +
      `&width=200&height=200`;
  }

  const handleDownload = async () => {
    setLoading(true);
    setDownloadError(null);
    try {
      await DataDownload(data, { onStatus: setDownloadStatus });
    } catch (error) {
      console.error(error);
      setDownloadError(error.message);
    } finally {
      setDownloadStatus(null);
      setLoading(false);
    }
  };

  return (
    <Modal
      show={true}
      onHide={onHide}
      size="xl"
      aria-labelledby="data-modal-title"
      // centered
      style={{ marginTop: '50px', paddingBottom: '50px' }}
    >
      <Modal.Header closeButton>
        <h4 id="data-modal-title">{formatTitle(data.title)}</h4>
      </Modal.Header>
      <Modal.Body>
        <div style={{ display: 'flex' }}>
          <p>{data.notes}</p>{' '}
          <div style={{ border: '2px' }}>
            {
              <img
                height={'200px'}
                width={'200px'}
                style={{
                  borderWidth: '0px',
                  borderRadius: '5px',
                  border: '5px solid',
                  borderColor: '#2C3E37',
                }}
                src={wms_thumbnail}
                alt={`Map thumbnail for ${formatTitle(data.title)}`}
              />
            }
          </div>
        </div>
        {data.extras && (
          <>
            <h4>Additional Information </h4>
            <Table>
              <tbody>
                {data.extras.map((data, i) => {
                  return (
                    <tr key={'extra' + i}>
                      <td width={200}>
                        {capitalize(data.key.replace(/_/g, ' '))}
                      </td>
                      <td>{data.value}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <DownloadStatus status={downloadStatus} error={downloadError} />
        {/* <Button
          variant="secondary"
          onClick={() => navitage(`/catalog/${data.name}`)}
        >
          Open on new page
        </Button> */}
        <Button
          style={{
            backgroundColor: '#a64500',
            marginRight: '4px',
            // border: 'none',
            borderColor: '#8a3a01',
          }}
          onClick={() => handleDownload()}
          disabled={loading}
        >
          {loading && (
            <>
              <Spinner animation="border" size="sm" />{' '}
            </>
          )}
          Download
        </Button>
        <Button variant="secondary" onClick={() => onHide()}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default DataModal;
